export interface Grade8Chapter {
  id: string;
  num: string;
  chNumber: string;
  title: string;
  hindiTitle?: string;
  englishTitle: string;
  page: string;
  category: "shlokas" | "stories" | "dialogue" | "grammar" | "preface";
  genreBadge: string;
  theme: string;
  grammarFocus: string;
  sampleVerse?: string;
  status: "available" | "in_curriculum" | "overview";
  icon: string;
}

export const GRADE_8_SYLLABUS: Grade8Chapter[] = [
  {
    "id": "g8_purovak",
    "num": "पुरोवाक्",
    "chNumber": "पुरोवाक्",
    "title": "पुरोवाक्",
    "hindiTitle": "प्रस्तावना / प्राक्कथन",
    "englishTitle": "Foreword",
    "page": "Page iii",
    "category": "preface",
    "genreBadge": "प्रस्तावना · Preface",
    "theme": "Educational vision and pedagogical guidelines for Grade 8 Sanskrit instruction according to national curriculum standards.",
    "grammarFocus": "भाषा-शिक्षण-उद्देश्यानि",
    "status": "overview",
    "icon": "📜"
  },
  {
    "id": "g8_bhumika",
    "num": "भूमिका",
    "chNumber": "भूमिका",
    "title": "भूमिका",
    "hindiTitle": "भूमिका / परिचय",
    "englishTitle": "Introduction",
    "page": "Page v",
    "category": "preface",
    "genreBadge": "परिचयः · Introduction",
    "theme": "Overview of foundational linguistic competencies: reading, chanting, comprehension, dialogue, and ethical culture in Sanskrit.",
    "grammarFocus": "अध्ययन-पद्धतिः",
    "status": "overview",
    "icon": "📖"
  },
  {
    "id": "grade8_prarthana",
    "num": "प्रार्थना",
    "chNumber": "मङ्गलाचरणम्",
    "title": "सरस्वतीप्रार्थना एवं राष्ट्र-गानम्",
    "hindiTitle": "सरस्वती वंदना एवं राष्ट्रगान",
    "englishTitle": "Prayer to Goddess Saraswati & The National Anthem",
    "page": "Pages 8 & xvi",
    "category": "shlokas",
    "genreBadge": "प्रार्थना · Sacred Hymn & Anthem",
    "theme": "Sacred invocation to Goddess Saraswati (जय जय हे भगवति सुरभारति) and the National Anthem (जन-गण-मन-अधिनायक) in authentic Sanskrit orthography.",
    "grammarFocus": "सम्बोधन-विभक्तिः, विशेषण-पदानि, संस्कृत-वर्तनी",
    "sampleVerse": "जय जय हे भगवति सुरभारति तव चरणौ प्रणमामः। नादब्रह्ममयि जय वागीश्वरि शरणं ते गच्छामः ॥",
    "status": "available",
    "icon": "🪕"
  },
  {
    "id": "grade8_ch1",
    "num": "Chapter 1",
    "chNumber": "प्रथमः पाठः",
    "title": "१. संगच्छध्वं संवदध्वम्",
    "hindiTitle": "साथ चलें, साथ बोलें",
    "englishTitle": "Walk Together, Speak Together",
    "page": "Pages 1–9",
    "category": "shlokas",
    "genreBadge": "ऋग्वेद-मन्त्रः · Unity & Harmony",
    "theme": "The timeless Rigvedic Samjnana Sukta (Sanghatana Sukta) advocating universal unity, harmonious dialogue, collective purpose, and heart-to-heart solidarity.",
    "grammarFocus": "लोट्-लकारः (Imperative Mood), प्रश्ननिर्माणम् (किम-शब्दाः), लट्-लोट् परिवर्तनम्",
    "sampleVerse": "संगच्छध्वं संवदध्वं सं वो मनांसि जानताम् । देवा भागं यथा पूर्वे संजानाना उपासते ॥",
    "status": "available",
    "icon": "🏛️"
  },
  {
    "id": "grade8_ch2",
    "num": "Chapter 2",
    "chNumber": "द्वितीयः पाठः",
    "title": "२. अल्पानामपि वस्तूनां संहतिः कार्यसाधिका",
    "hindiTitle": "छोटी-छोटी वस्तुओं का संगठन भी कार्य सिद्ध करने वाला होता है",
    "englishTitle": "Unity of Even Small Things Achieves the Task",
    "page": "Pages 10–22",
    "category": "stories",
    "genreBadge": "नीतिकथा · Animal Fable",
    "theme": "Celebrated Hitopadesha fable of the united flock of doves lifting the hunter snare through collective solidarity.",
    "grammarFocus": "ल्यप्-प्रत्ययः (वि + कॄ + ल्यप् = विकीर्य), सन्धिविच्छेदः, षष्ठी-विभक्तिः",
    "sampleVerse": "लघूनामपि वस्तूनां संहतिः कार्यसाधिका । एकचित्तीभूय जालमादाय उड्डीयताम् ॥",
    "status": "available",
    "icon": "🕊️"
  },
  {
    "id": "grade8_ch3",
    "num": "Chapter 3",
    "chNumber": "तृतीयः पाठः",
    "title": "३. सुभाषितरसं पीत्वा जीवनं सफलं कुरु",
    "hindiTitle": "सुंदर वचनों के रस को पीकर जीवन सफल करो",
    "englishTitle": "Make Life Successful by Drinking the Nectar of Good Sayings",
    "page": "Pages 24–35",
    "category": "shlokas",
    "genreBadge": "सुभाषितानि · Life Wisdom",
    "theme": "Timeless classical epigrams on genuine virtue, natural humility of the great, testing pure gold vs human character, eight illuminating qualities, and unyielding human effort.",
    "grammarFocus": "सुभाषित-मञ्जरी, विसर्गसन्धिः (नम्रास्तरवः), यण्-सन्धिः (अभ्युपैति), तत्पुरुषसमासः",
    "sampleVerse": "गायन्ति देवाः किल गीतकानि धन्यास्तु ते भारतभूमिभागे । स्वर्गापवर्गास्पदमार्गभूते भवन्ति भूयः पुरुषाः सुरत्वात् ॥",
    "status": "available",
    "icon": "🍯"
  },
  {
    "id": "grade8_ch4",
    "num": "Chapter 4",
    "chNumber": "चतुर्थः पाठः",
    "title": "४. प्रणम्यो देशभक्तोऽयं गोपबन्धुर्महामनाः",
    "hindiTitle": "यह महान देशभक्त गोपबंधु प्रणाम करने योग्य है",
    "englishTitle": "Worthy of Salutation is This High-Minded Patriot Gopabandhu",
    "page": "Pages 36–44",
    "category": "stories",
    "genreBadge": "चरितम् · Patriotic Biography",
    "theme": "The moving and heroic life of Utkalmani Pandit Gopabandhu Das: his supreme self-sacrifice, unconditional humanitarian flood relief in Odisha, the Satyavadi open-air forest school, and unyielding love for Bharat.",
    "grammarFocus": "यत्-तद् सर्वनाम-प्रयोगाः, अनीयर्/ण्यत्-प्रत्ययः (प्रणम्यः), भूतकालिक-लङ्-लकारः, विसर्ग-उत्व-सन्धिः",
    "sampleVerse": "मम वपुः देशहिताय पततु, देशस्य प्रगत्यै मम सर्वस्वं लीनं भवतु।",
    "status": "available",
    "icon": "🇮🇳"
  },
  {
    "id": "grade8_ch5",
    "num": "Chapter 5",
    "chNumber": "पञ्चमः पाठः",
    "title": "५. गीता सुगीता कर्तव्या",
    "hindiTitle": "गीता का अच्छी तरह गान (स्वाध्याय) करना चाहिए",
    "englishTitle": "The Gita Should Be Well Studied and Sung",
    "page": "Pages 49–58",
    "category": "shlokas",
    "genreBadge": "श्रीमद्भगवद्गीता · Spiritual Ethics",
    "theme": "Core spiritual and ethical teachings of the Bhagavad Gita: Nishkama Karma, mental equipoise (Sthitadhi), self-mastery, sense restraint, vocal austerity, and the causal chain from anger to downfall.",
    "grammarFocus": "तव्यत्-प्रत्ययः (कर्तव्या), क्तवतु-प्रत्ययः, विसर्ग-उत्व-पूर्वरूप-सन्धयः, कर्मणि-प्रयोगः",
    "sampleVerse": "गीता सुगीता कर्तव्या किमन्यैः शास्त्रविस्तरैः । या स्वयं पद्मनाभस्य मुखपद्माद् विनिःसृता ॥",
    "status": "available",
    "icon": "🕉️"
  },
  {
    "id": "grade8_ch6",
    "num": "Chapter 6",
    "chNumber": "षष्ठः पाठः",
    "title": "६. डिजिभारतम् – युगपरिवर्तनम्",
    "hindiTitle": "डिजिटल इंडिया – युग का परिवर्तन",
    "englishTitle": "DigiBharat – The Transformation of an Era",
    "page": "Pages 61–66",
    "category": "dialogue",
    "genreBadge": "विज्ञान-प्रौद्योगिकी · Modern India",
    "theme": "India monumental technological stride into the digital age: e-governance, digital wallets, green paperless environment, mobile connectivity, and seamless cashless transactions.",
    "grammarFocus": "कर्मवाच्य-प्रयोगाः (पठ्यते, लिख्यते, कृत्यन्ते), ल्युट्-प्रत्ययः, आधुनिक-पारिभाषिक-शब्दाः",
    "sampleVerse": "अद्य सम्पूर्णविश्वे डिजिभारतम् इत्यस्य चर्चा श्रूयते। कालपरिवर्तनेन सह मानवस्य आवश्यकता अपि परिवर्तते।",
    "status": "available",
    "icon": "💻"
  },
  {
    "id": "grade8_ch7",
    "num": "Chapter 7",
    "chNumber": "सप्तमः पाठः",
    "title": "७. मञ्जुलमञ्जूषा सुन्दरसुरभाषा",
    "hindiTitle": "सुंदर संदूक, सुंदर देवभाषा (संस्कृत)",
    "englishTitle": "Beautiful Box, Beautiful Language of Gods",
    "page": "Pages 75–83",
    "category": "shlokas",
    "genreBadge": "काव्यम् · Linguistic Glory",
    "theme": "Lyrical tribute celebrating Sanskrit matchless musicality, phonological precision, scientific vocabulary, nine aesthetic rasas, and vast literary inheritance.",
    "grammarFocus": "सन्धयः, समास-परिचयः (तत्पुरुष, कर्मधारय), नवरसाः, सम्बोधन-रूपाणि",
    "sampleVerse": "मुनिवरविकसितकविवरविलसित-मञ्जुलमञ्जूषा सुन्दरसुरभाषा । अयि मातस्तव पोषणक्षमता मम वचनातीता सुन्दरसुरभाषा ॥",
    "status": "available",
    "icon": "💎"
  },
  {
    "id": "grade8_ch8",
    "num": "Chapter 8",
    "chNumber": "अष्टमः पाठः",
    "title": "८. पश्यत कोणमैशान्यं भारतस्य मनोहरम्",
    "hindiTitle": "भारत के सुंदर उत्तर-पूर्व कोने को देखो",
    "englishTitle": "Behold the Beautiful North-Eastern Corner of India",
    "page": "Pages 85–88",
    "category": "dialogue",
    "genreBadge": "भूगोलः · Geography & Culture",
    "theme": "An inspiring cultural and geographical exploration of India Seven Sisters & Brother Sikkim: lush green nature, Barak-Brahmaputra rivers, independent history, and bamboo crafts.",
    "grammarFocus": "प्रत्ययाः (तुमुन्, अनीयर्, ल्यप्, क्त), विशेषण-विशेष्य-सम्बन्धः, षष्ठी-विभक्तिः",
    "sampleVerse": "अद्वयं मत्रयं चैव न-त्रि-युक्तं तथाद्वयम् । सप्तराज्यसमूहोऽयं भगिनीसप्तकं मतम् ॥ तेन युक्तो लघुः भ्राता सिक्किमः इति विश्रुतः ॥",
    "status": "available",
    "icon": "🏞️"
  },
  {
    "id": "grade8_ch9",
    "num": "Chapter 9",
    "chNumber": "नवमः पाठः",
    "title": "९. कोऽरुक् ? कोऽरुक् ? कोऽरुक् ?",
    "hindiTitle": "निरोगी कौन है? निरोगी कौन है? निरोगी कौन है?",
    "englishTitle": "Who is Free from Disease?",
    "page": "Pages 97–105",
    "category": "dialogue",
    "genreBadge": "आयुर्वेदः · Holistic Health",
    "theme": "Vagbhata classic Ayurvedic health dialogue: the secret of holistic well-being lies in being हितभुक् (wholesome food), मितभुक् (moderate food), and ऋतुभुक् (seasonal food).",
    "grammarFocus": "पूर्वरूप-सन्धिः (कोऽरुक् = कः + अरुक्), विशेषण-विशेष्य-मेलनम्, आहार-दिनचर्या-नियमाः",
    "sampleVerse": "तच्च नित्यं प्रयुञ्जीत स्वास्थ्यं येनानुवर्तते । अजातानां विकाराणामनुत्पत्तिकरं च यत् ॥ — हितभुक्, मितभुक्, ऋतुभुक्!",
    "status": "available",
    "icon": "🌿"
  },
  {
    "id": "grade8_ch10",
    "num": "Chapter 10",
    "chNumber": "दशमः पाठः",
    "title": "१०. सन्निमित्ते वरं त्यागः (क-भागः)",
    "hindiTitle": "अच्छे कार्य के लिए त्याग करना श्रेष्ठ है (भाग क)",
    "englishTitle": "Sacrifice for a Noble Cause is Better (Part A)",
    "page": "Pages 111–122",
    "category": "stories",
    "genreBadge": "नीतिकथा · Noble Sacrifice",
    "theme": "From Hitopadesha: The inspiring tale of prince Viravara, his supreme loyalty to King Shudraka, righteous fourfold salary division, and readiness to sacrifice for the sovereign before Rajalaxmi.",
    "grammarFocus": "अन्वय-रचना, भूतकालिक-प्रयोगाः (स्म, क्त, क्तवतु, लङ्), सन्धि-विच्छेदः, सर्वनामपदानि (चतुर्थी)",
    "sampleVerse": "सन्निमित्ते वरं त्यागो विनाशे नियते सति । यदि त्वया स्वस्य सर्वतः प्रियं वस्तु उपहारः क्रियेत, तदा पुनर्जीविष्यति राजा शूद्रको वर्षाणां शतम्॥",
    "status": "available",
    "icon": "⚖️"
  },
  {
    "id": "grade8_ch11",
    "num": "Chapter 11",
    "chNumber": "एकादशः पाठः",
    "title": "११. एकादशः पाठः: सन्निमित्ते वरं त्यागः (ख-भागः)",
    "hindiTitle": "अच्छे कार्य के लिए त्याग करना श्रेष्ठ है (भाग ख)",
    "englishTitle": "Sacrifice for a Noble Cause is Better (Part B)",
    "page": "Pages 124–135",
    "category": "stories",
    "genreBadge": "नीतिकथा · Noble Sacrifice",
    "theme": "Hitopadesha conclusion: Viravara family sacrifice at Goddess Sarvamangala temple, King Shudraka profound affection for his servant (भृत्यवात्सल्य), divine restoration of the family, and coronation over Karnataka.",
    "grammarFocus": "वाच्य-प्रकरणम् (कर्तृवाच्य, कर्मवाच्य, भाववाच्य), अकर्मक-सकर्मक-धातवः, सन्धिकार्यम्, पदच्छेदः",
    "sampleVerse": "धनानि जीवितञ्चैव परार्थे प्राज्ञ उत्सृजेत्। सन्निमित्ते वरं त्यागो विनाशे नियते सति ॥ — जायन्ते च म्रियन्ते च मादृशाः क्षुद्रजन्तवः। अनेन सदृशो लोके न भूतो न भविष्यति ॥",
    "status": "available",
    "icon": "🕊️"
  },
  {
    "id": "grade8_ch12",
    "num": "Chapter 12",
    "chNumber": "द्वादशः पाठः",
    "title": "१२. सम्यग्वर्णप्रयोगेण ब्रह्मलोके महीयते",
    "hindiTitle": "वर्णों के सही प्रयोग से ब्रह्मलोक में महिमा मिलती है",
    "englishTitle": "One Exalted in the Realm of Brahma by Right Use of Words",
    "page": "Pages 137–145",
    "category": "grammar",
    "genreBadge": "पाणिनीय-शिक्षा · Phonetics & Reader Qualities",
    "theme": "Paniniya Shiksha doctrine on pristine pronunciation: the tale of Vritrasura/Indrashatru accent error, tigress carrying cubs metaphor for gentle yet firm articulation, 6 qualities of ideal readers (पाठकगुणाः), and 6 defects of poor readers (पाठकाधमाः).",
    "grammarFocus": "तृतीया-विभक्तिः (प्रयोगेण), कर्मणि-लट् (महीयते), पाठकगुणाः (गीती शीघ्री etc.), सन्धिः, पदच्छेदः, श्लोकान्वयः",
    "sampleVerse": "व्याघ्री यथा हरेत्पुत्रान् दंष्ट्राभ्यां न च पीडयेत् । भीता पतनभेदाभ्यां तद्वद्वर्णान् प्रयोजयेत् ॥ — गीती शीघ्री शिरःकम्पी तथा लिखितपाठकः । अनर्थज्ञोऽल्पकण्ठश्च षडेते पाठकाधमाः ॥",
    "status": "available",
    "icon": "🗣️"
  },
  {
    "id": "grade8_ch13",
    "num": "Chapter 13",
    "chNumber": "त्रयोदशः पाठः",
    "title": "१३. (क) वर्णोच्चारण-शिक्षा १",
    "hindiTitle": "वर्णों के उच्चारण की शिक्षा १",
    "englishTitle": "Education of Phonetics / Pronunciation 1",
    "page": "Pages 146–156",
    "category": "grammar",
    "genreBadge": "ध्वनिविज्ञानम् · Places & Tools of Articulation",
    "theme": "Anatomy of voice production and phonetics: 4 bodily systems (muscular, air-pressure, phonatory, articulatory), 6 places (स्थानम्) with the flute-holes analogy, and active tools (करणम्) with the playing-fingers analogy.",
    "grammarFocus": "ध्वनिविज्ञानम्, षडुच्चारणस्थानानि (कण्ठ, तालु, मूर्धा, दन्त, ओष्ठ, नासिका), करणम् (जिह्वा, स्वस्थानकरणम्), बाह्य-आभ्यन्तर-क्रमः",
    "sampleVerse": "मुरल्याः अङ्गुलिच्छिद्राणि आस्यस्य स्थानानि इव, मुरलीं वादयन्त्यः अङ्गुलयः आस्यस्य करणानि इव व्यवहरन्ति।",
    "status": "available",
    "icon": "🔤"
  },
  {
    "id": "grade8_app1",
    "num": "Appendix 1",
    "chNumber": "परिशिष्टम् १",
    "title": "(ख) परिशिष्टम् १: व्याकरणम्",
    "hindiTitle": "परिशिष्ट १: व्याकरण",
    "englishTitle": "Appendix 1: Grammar",
    "page": "Pages 159–165",
    "category": "grammar",
    "genreBadge": "व्याकरणम् · Prefixes, Suffixes & Cases",
    "theme": "Core Paninian grammatical structures: 22 Upasargas with semantic shifts and hri derivatives, Krit suffixes (ktva, lyap, tumun, ktavatu past active participle), 6 Karakas, Upapada case rules, and vowel/consonant Sandhis.",
    "grammarFocus": "उपसर्गाः (२२), क्त्वा, ल्यप्, तुमुन्, क्तवतु (त्रिषु लिङ्गेषु), षट् कारकाणि, उपपद-विभक्तयः, अयादि-पूर्वरूप-व्यञ्जन-सन्धयः",
    "sampleVerse": "उपसर्गेण धात्वर्थो बलादन्यत्र नीयते । प्रहाराहारसंहारविहारपरिहारवत् ॥ — क्रियान्वयि कारकम् ।",
    "status": "available",
    "icon": "📐"
  },
  {
    "id": "g8_app2",
    "num": "Appendix 2",
    "chNumber": "परिशिष्टम् २",
    "title": "(ख) परिशिष्टम् २: शब्दरूपाणि",
    "hindiTitle": "परिशिष्ट २: शब्द-रूप",
    "englishTitle": "Appendix 2: Noun Declensions",
    "page": "Pages 166–172",
    "category": "grammar",
    "genreBadge": "शब्दरूपाणि · Noun Paradigms",
    "theme": "Comprehensive declension tables for masculine, feminine, neuter vowel and consonant stems, pronouns (अस्मद्, युष्मद्, तद्, किम्), and numerals.",
    "grammarFocus": "अजन्त-हलन्त-रूपाणि, सर्वनाम-रूपाणि, त्रिषु लिङ्गेषु रूपाणि",
    "status": "in_curriculum",
    "icon": "📊"
  },
  {
    "id": "g8_app3",
    "num": "Appendix 3",
    "chNumber": "परिशिष्टम् ३",
    "title": "(ग) परिशिष्टम् ३: धातुरूपाणि",
    "hindiTitle": "परिशिष्ट ३: धातु-रूप",
    "englishTitle": "Appendix 3: Verb Conjugations",
    "page": "Page 173",
    "category": "grammar",
    "genreBadge": "धातुरूपाणि · Verb Conjugations",
    "theme": "Full conjugations across 5 essential Lakarams (लट्, लोट्, लङ्, विधिलिङ्, लृट्) for essential roots in Parasmaipada and Atmanepada.",
    "grammarFocus": "पञ्च-लकाराः, परस्मैपद-आत्मनेपद-विभागः, गण-परिचयः",
    "status": "in_curriculum",
    "icon": "⚡"
  }
];
